export var ACTION;
(function (ACTION) {
    ACTION["PHONE_NUMBER"] = "PHONE_NUMBER";
    ACTION["WHATSAPP_CHECK"] = "WHATSAPP_CHECK";
    ACTION["WHATSAPP_UNCHECK"] = "WHATSAPP_UNCHECK";
    ACTION["CONTINUE"] = "CONTINUE";
    ACTION["ENABLE_CONTINUE"] = "ENABLE_CONTINUE";
    ACTION["DISABLE_CONTINUE"] = "DISABLE_CONTINUE";
    ACTION["PRIVACY"] = "PRIVACY";
    ACTION["T_AND_C"] = "T_AND_C";
    ACTION["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    ACTION["PROCEED"] = "PROCEED";
})(ACTION || (ACTION = {}));
